import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { checkRole, getBrokersList } from '../../../utils/utils.common';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { StaffService } from '../../staffs/staff-service/staff.service';

@Component({
  selector: 'app-manifest',
  templateUrl: './manifest.component.html',
  styleUrls: ['./manifest.component.css']
})
export class ManifestComponent implements OnInit, OnDestroy {
  @ViewChild('timer', { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  filterdataList = [];
  stationManagerWiseTripList = [];

  todayDate;
  isShowAllTrips = false;
  search: any;
  timeZone;
  user;
  completedTripModalObj;
  tripDetailModalObj;
  skip = 0;

  partialEditModalObj;
  isShowStatusDropdown = false;
  tripStatuses = [
    { label: 'Unassigned', status: 'pending', isChecked: true },
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: true },
    { label: 'Arrived', status: 'arrived', isChecked: true },
    { label: 'In Progress', status: 'started', isChecked: true },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];

  preDriverList = {};
  corporateUsers = [];
  selectedTrip;
  selectedTripId;

  preLevelOfServices = {};
  preSpaceTypes = {};
  selectedDriver = [];
  driverListMain = [];
  filteredDrivers = [];

  filteredStationManager = [];
  selectedStationManager = [];
  stationManagerList = [];
  preStaffList = {};
  isAllowRates = false;
  isRdispatcher = false;

  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private socketService: SocketService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.listenSocket();
    this.getUser();
  }

  listenSocket() {
    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }
          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();

          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.getLevelOfService();
          this.getSpaceTypes();
          this.getDriverList();
          this.getCorporateUserList();
          this.getTrips();
          this.getStaffList();
          this.isAllowRates = checkRole(this.user);

        }
      });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {

          this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          if (this.isRdispatcher) {
            data = data.filter(item => item.stationManager === this.user.sId);
          }

          this.driverListMain = data;
        }
      },
    );
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  onChangeStatus() {
    this.getTrips();
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onDateChange(event) {
    this.todayDate = event.toISOString();
    this.getTrips();
  }

  onTimerComplete(): void {
    this.timer.init();
    this.getTrips();
  }

  getTrips() {
    let jobStatuses = [];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered');
          jobStatuses.push('accepted');
        } else {
          jobStatuses.push(t.status);
        }
      }
    })
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.todayDate,
      skip: this.skip,
      jobStatuses
    };

    this.assignTripService.getAssignManifestList(object)
    .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        this.filterdataList = [];
        this.filteredDrivers = [];
        this.filteredStationManager = [];
        if (data) {
          this.filterdataList = data;

          this.filterdataList.forEach(trip => {

            if (trip.driver) {

              if (this.isRdispatcher) {
                const mDriver = this.preDriverList[trip.driver];
                if (mDriver && mDriver.stationManager === this.user.sId) {
                  this.filteredDrivers.push(this.preDriverList[trip.driver]);
                }
              } else {
                this.filteredDrivers.push(this.preDriverList[trip.driver]);
              }
            }
            if (trip.driver && this.preDriverList[trip.driver]) {
              this.filteredStationManager.push(this.preDriverList[trip.driver].stationManager);
            }
          });

          this.filteredDrivers = _.uniq( this.filteredDrivers, '_id').sort();
          this.filteredStationManager = _.uniq(this.filteredStationManager).sort();
          this.stationManagerWiseTrips();
        }
        this.timer.start();
      }, err => {
        this.timer.start();
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  stationManagerWiseTrips(){
    if(this.selectedStationManager && this.selectedStationManager.length){
    this.stationManagerWiseTripList= this.filterdataList.filter(item => item.driver && this.preDriverList[item.driver] && this.preDriverList[item.driver].stationManager && this.selectedStationManager.includes(this.preDriverList[item.driver].stationManager) );
    }else{
      this.stationManagerWiseTripList = this.filterdataList;
    }
  }


  editTrip(assign) {
    this.selectedTrip = assign;
  }

  onEditTrip(event) {
    if (event) {
      const idx = this.filterdataList.findIndex(t => t._id === event._id);

      if (moment(event.appointmentTime).format("YYYY-MM-DD") !== moment(this.filterdataList[idx].appointmentTime).format("YYYY-MM-DD") || moment(event.scheduleTime).format("YYYY-MM-DD") !== moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")) {
        this.filterdataList.splice(idx, 1);
      } else {
        this.filterdataList[idx] = event;
      }
      if (event.status === 'archived') {
        this.filterdataList.splice(idx, 1);
      }

      if (event.jobStatus === 'cancelled' || event.status === 'cancelled') {
        const isCancelledSelected = this.tripStatuses.find(ts => ts.status === 'cancelled' && ts.isChecked);
        if (!isCancelledSelected) {
          this.filterdataList.splice(idx, 1);
        }
      }
      this.selectedTrip = null;
    }
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  getDriverByID(id) {
    return this.preDriverList[id];
  }

  getCorporateByID(id) {
    return this.corporateUsers[id];
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id;
  }

  viewTripDetails(trip) {
    const obj = JSON.parse(JSON.stringify(trip));
    obj.driver = this.getDriverByID(trip.driver);
    this.tripDetailModalObj = obj;
  }

  updateTripData(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
      if (selectedTrip) {
        selectedTrip.attachment = evt.attachment;
        selectedTrip.companyNote = evt.companyNote;
        selectedTrip.dispatchNoteTwo = evt.dispatchNoteTwo;
      }
    }
  }

  setPartialEditModal(trip) {
    const obj = JSON.parse(JSON.stringify(trip));
    obj.cooperate = this.getCorporateByID(trip.cooperate);
    this.partialEditModalObj = obj;
  }


  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if(data) {
          this.stationManagerList = data
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }


    getLevelOfService() {
      this.levelOfServiceService
        .getLevelOfServices({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    }

    getSpaceTypes() {
      this.levelOfServiceService
        .getSpaceTypes({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    }


  ngOnDestroy(): void {
  }
}
